import { funds_select_actions } from './ActionType';

export const FundsSelect = (state = {
        isLoading: false,
        errMess: null,
        data: null
    }, action) => {
    switch(action.type){
        case funds_select_actions.add:
            return {...state, isLoading: false, errMess: null, data: action.payload};
        case funds_select_actions.loading:
            return {...state, isLoading: true, errMess: null, data:null};
        case funds_select_actions.failed:
            return {...state, isLoading: false, errMess: action.payload, data:null};
        case funds_select_actions.reset:
            return {...state, isLoading: false, errMess: null, data:null};
        default:
            return state;
    }
};